import {
  GoogleTransport,
  ContactTransport,
  ContactRequest,
  TContactRequest,
  HttpClient,
} from 'lib';

class ContactService {
  private transport: ContactTransport;

  private transportGoogle: GoogleTransport;

  constructor(httpClient: HttpClient) {
    this.transport = new ContactTransport(httpClient);
    this.transportGoogle = new GoogleTransport(httpClient);
  }

  async sendQuestionWithCaptcha(
    data: TContactRequest,
    captcha: string,
  ): Promise<boolean> {
    const verifiedCaptcha = await this.transportGoogle.verifyCaptcha(captcha);

    if (!verifiedCaptcha?.status) {
      throw Error('Captcha validation error');
    }

    return this.sendQuestion(data);
  }

  async sendQuestion(data: TContactRequest): Promise<boolean> {
    const request = new ContactRequest(data);

    return this.transport.sendQuestion(request);
  }
}

export const contactService = new ContactService(new HttpClient());
